import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { BagPaymentCta } from './BagPaymentCta';

// ────────────────────────────────────────────────────────────────────────────

export const BagRedeemGiftCardCta = (props: RedeemGiftCardCtaProps) => {
  const { formatMessage } = useIntl();

  return (
    <BagPaymentCta
      icon="IconPlus"
      message={formatMessage(messages.redeemGiftcard)}
      onPress={props.onPress}
    />
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  redeemGiftcard: {
    defaultMessage: 'Redeem gift card',
    description: 'Bag | Payment method picker | Redeem gift card',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type RedeemGiftCardCtaProps = {
  onPress: () => void;
};
